import { i18n } from "app/i18n/i18n";
import { useFetchParse } from "lib/hooks/useFetchParse";

export const useGetPeriodicals = (query = "", formData) => {
  let [autoCompletePeriodicals] = useFetchAutocomplete(query, "periodical");
  let menuPeriodicals = formData.periodicals.optionsWithHeadings;
  return (query ? autoCompletePeriodicals : menuPeriodicals) || [];
};

function useFetchAutocomplete(query, category) {
  const url = "/research/japi/pub/search/autocomplete/category/" + category;
  const request = { filter: query, language: [i18n.getLanguage()] };

  let [data, isLoading, error] = useFetchParse(url, JSON.stringify(request), "POST", query, fParseSuggestions);
  return [data, isLoading, error];
}

const fParseSuggestions = (response) => {
  return response?.suggest?.autocomplete[0]?.options?.map((el) => el._source.name) || [];
};
